import { BaseTypeSchema } from "./schema/BaseTypeSchema";
import { BoolSchema } from "./schema/type/BoolSchema";
import { IntegerSchema } from "./schema/type/IntegerSchema";
import { FloatSchema } from "./schema/type/FloatSchema";
import { StringSchema } from "./schema/type/StringSchema";
import { DateSchema } from "./schema/type/DateSchema";
import { ArraySchema } from "./schema/type/ArraySchema";
import { ObjectSchema } from "./schema/type/ObjectSchema";
import { AnySchema } from "./schema/type/AnySchema";
import { TinyIntSchema } from "./schema/type/TinyIntSchema";
import { SmallIntSchema } from "./schema/type/SmallIntSchema";
import { MediumIntSchema } from "./schema/type/MediumIntSchema";
import { BigIntSchema } from "./schema/type/BigIntSchema";
import { DoubleSchema } from "./schema/type/DoubleSchema";
import { DecimalSchema } from "./schema/type/DecimalSchema";
import { RealSchema } from "./schema/type/RealSchema";
import { DateTimeSchema } from "./schema/type/DateTimeSchema";
import { TimeSchema } from "./schema/type/TimeSchema";
import { DurationSchema } from "./schema/type/DurationSchema";
import { EnumSchema } from "./schema/type/EnumSchema";
import { VariableType } from "./schema/VariableType";
import { BaseLooper } from "./looper/BaseLooper";
import { EmailSchema } from "./schema/type/EmailSchema";
import { PhoneSchema } from "./schema/type/PhoneSchema";
import { IPV4Schema } from "./schema/type/IPV4Schema";
import { IPV6Schema } from "./schema/type/IPV6Schema";
import { MoneySchema } from "./schema/type/MoneySchema";
import { TimeZoneSchema } from "./schema/type/TimeZoneSchema";
import { IPV4RangeSchema } from "./schema/type/IPV4RangeSchema";
import { IPV6RangeSchema } from "./schema/type/IPV6RangeSchema";
import { VersionSchema } from "./schema/type/VersionSchema";
import { ColorSchema } from "./schema/type/ColorSchema";
import { FontSchema } from "./schema/type/FontSchema";
import { FilePathSchema } from "./schema/type/FilePathSchema";
import { URLSchema } from "./schema/type/URLSchema";
import { EntitySchema } from "./schema/type/EntitySchema";
import { TypeSchema } from "./schema/type/TypeSchema";
import { VariableSchema } from "./schema/type/VariableSchema";

export abstract class BaseTypeBuilder<Output> extends BaseLooper 
{
    protected schema: BaseTypeSchema | null;
    constructor(schema: BaseTypeSchema | null)
    {
        super();
        this.schema = schema;
        /* VariableType */
        this._toAny = this._toAny.bind(this);
        this._toBool = this._toBool.bind(this);
        this._toTinyInt = this._toTinyInt.bind(this);
        this._toSmallInt = this._toSmallInt.bind(this);
        this._toMediumInt = this._toMediumInt.bind(this);
        this._toInteger = this._toInteger.bind(this);
        this._toBigInt = this._toBigInt.bind(this);
        this._toFloat = this._toFloat.bind(this);
        this._toDouble = this._toDouble.bind(this);
        this._toDecimal = this._toDecimal.bind(this);
        this._toReal = this._toReal.bind(this);
        this._toMoney = this._toMoney.bind(this);
        this._toString = this._toString.bind(this);
        this._toDate = this._toDate.bind(this);
        this._toTime = this._toTime.bind(this);
        this._toDateTime = this._toDateTime.bind(this);
        this._toTimeZone = this._toTimeZone.bind(this);
        this._toDuration = this._toDuration.bind(this);
        this._toEmail = this._toEmail.bind(this);
        this._toPhone = this._toPhone.bind(this);
        this._toVersion = this._toVersion.bind(this);
        this._toIPV4 = this._toIPV4.bind(this);
        this._toIPV6 = this._toIPV6.bind(this);
        this._toIPV4Range = this._toIPV4Range.bind(this);
        this._toIPV6Range = this._toIPV6Range.bind(this);
        this._toColor = this._toColor.bind(this);
        this._toFont = this._toFont.bind(this);
        this._toFilePath = this._toFilePath.bind(this);
        this._toURL = this._toURL.bind(this);
        this._toEnum = this._toEnum.bind(this);
        this._toEntity = this._toEntity.bind(this);
        this._toArray = this._toArray.bind(this);
        this._toObject = this._toObject.bind(this);
        this._toType = this._toType.bind(this);
        this._toVariable = this._toVariable.bind(this);
        //
        this.runSynch = this.runSynch.bind(this);
    }
    override getAll(_: (schema: BaseTypeSchema) => void): BaseTypeSchema[]
    {
        return [];
    }
    runSynch(callback: (schema: BaseTypeSchema) => void): Output | null
    {
        if (this.schema == null)
            return null;
        if (callback)
            callback(this.schema);
        /* VariableType */
        if (this.schema.type == VariableType.Any)
            return this._toAny(this.schema as AnySchema);
        if (this.schema.type == VariableType.Boolean)
            return this._toBool(this.schema as BoolSchema);
        if (this.schema.type == VariableType.TinyInt)
            return this._toTinyInt(this.schema as TinyIntSchema);
        if (this.schema.type == VariableType.SmallInt)
            return this._toSmallInt(this.schema as SmallIntSchema);
        if (this.schema.type == VariableType.MediumInt)
            return this._toMediumInt(this.schema as MediumIntSchema);
        if (this.schema.type == VariableType.Integer)
            return this._toInteger(this.schema as IntegerSchema);
        if (this.schema.type == VariableType.BigInt)
            return this._toBigInt(this.schema as BigIntSchema);
        if (this.schema.type == VariableType.Float)
            return this._toFloat(this.schema as FloatSchema);
        if (this.schema.type == VariableType.Double)
            return this._toDouble(this.schema as DoubleSchema);
        if (this.schema.type == VariableType.Decimal)
            return this._toDecimal(this.schema as DecimalSchema);
        if (this.schema.type == VariableType.Real)
            return this._toReal(this.schema as RealSchema);
        if (this.schema.type == VariableType.Money)
            return this._toMoney(this.schema as MoneySchema);
        if (this.schema.type == VariableType.String)
            return this._toString(this.schema as StringSchema);
        if (this.schema.type == VariableType.Date)
            return this._toDate(this.schema as DateSchema);
        if (this.schema.type == VariableType.Time)
            return this._toTime(this.schema as TimeSchema);
        if (this.schema.type == VariableType.DateTime)
            return this._toDateTime(this.schema as DateTimeSchema);
        if (this.schema.type == VariableType.TimeZone)
            return this._toTimeZone(this.schema as TimeZoneSchema);
        if (this.schema.type == VariableType.Duration)
            return this._toDuration(this.schema as DurationSchema);
        if (this.schema.type == VariableType.Email)
            return this._toEmail(this.schema as EmailSchema);
        if (this.schema.type == VariableType.Phone)
            return this._toPhone(this.schema as PhoneSchema);
        if (this.schema.type == VariableType.Version)
            return this._toVersion(this.schema as VersionSchema);
        if (this.schema.type == VariableType.IPV4)
            return this._toIPV4(this.schema as IPV4Schema);
        if (this.schema.type == VariableType.IPV6)
            return this._toIPV6(this.schema as IPV6Schema);
        if (this.schema.type == VariableType.IPV4Range)
            return this._toIPV4Range(this.schema as IPV4RangeSchema);
        if (this.schema.type == VariableType.IPV6Range)
            return this._toIPV6Range(this.schema as IPV6RangeSchema);
        if (this.schema.type == VariableType.Color)
            return this._toColor(this.schema as ColorSchema);
        if (this.schema.type == VariableType.Font)
            return this._toFont(this.schema as FontSchema);
        if (this.schema.type == VariableType.FilePath)
            return this._toFilePath(this.schema as FilePathSchema);
        if (this.schema.type == VariableType.URL)
            return this._toURL(this.schema as URLSchema);
        if (this.schema.type == VariableType.Enum)
            return this._toEnum(this.schema as EnumSchema);
        if (this.schema.type == VariableType.Entity)
            return this._toEntity(this.schema as EntitySchema);
        if (this.schema.type == VariableType.Array)
            return this._toArray(this.schema as ArraySchema, callback);
        if (this.schema.type == VariableType.Object)
            return this._toObject(this.schema as ObjectSchema, callback);
        if (this.schema.type == VariableType.Type)
            return this._toType(this.schema as TypeSchema);
        if (this.schema.type == VariableType.Variable)
            return this._toVariable(this.schema as VariableSchema);
        throw new Error("Invalid type of variable: " + this.schema.type);
    }
    /* VariableType */
    protected abstract _toAny(schema: AnySchema): Output;
    protected abstract _toBool(schema: BoolSchema): Output;
    protected abstract _toTinyInt(schema: TinyIntSchema): Output;
    protected abstract _toSmallInt(schema: SmallIntSchema): Output;
    protected abstract _toMediumInt(schema: MediumIntSchema): Output;
    protected abstract _toInteger(schema: IntegerSchema): Output;
    protected abstract _toBigInt(schema: BigIntSchema): Output;
    protected abstract _toFloat(schema: FloatSchema): Output;
    protected abstract _toDouble(schema: DoubleSchema): Output;
    protected abstract _toDecimal(schema: DecimalSchema): Output;
    protected abstract _toReal(schema: RealSchema): Output;
    protected abstract _toMoney(schema: MoneySchema): Output;
    protected abstract _toString(schema: StringSchema): Output;
    protected abstract _toDateTime(schema: DateTimeSchema): Output;
    protected abstract _toTimeZone(schema: TimeZoneSchema): Output;
    protected abstract _toDate(schema: DateSchema): Output;
    protected abstract _toTime(schema: TimeSchema): Output;
    protected abstract _toDuration(schema: DurationSchema): Output;
    protected abstract _toEmail(schema: EmailSchema): Output;
    protected abstract _toPhone(schema: PhoneSchema): Output;
    protected abstract _toVersion(schema: VersionSchema): Output;
    protected abstract _toIPV4(schema: IPV4Schema): Output;
    protected abstract _toIPV6(schema: IPV6Schema): Output;
    protected abstract _toIPV4Range(schema: IPV4RangeSchema): Output;
    protected abstract _toIPV6Range(schema: IPV6RangeSchema): Output;
    protected abstract _toColor(schema: ColorSchema): Output;
    protected abstract _toFont(schema: FontSchema): Output;
    protected abstract _toFilePath(schema: FilePathSchema): Output;
    protected abstract _toURL(schema: URLSchema): Output;
    protected abstract _toEnum(schema: EnumSchema): Output;
    protected abstract _toEntity(schema: EntitySchema): Output;
    protected abstract _toArray(schema: ArraySchema, callback: (schema: BaseTypeSchema) => void): Output;
    protected abstract _toObject(schema: ObjectSchema, callback: (schema: BaseTypeSchema) => void): Output;
    protected abstract _toType(schema: TypeSchema): Output;
    protected abstract _toVariable(schema: VariableSchema): Output;
}